<template>
  <div class="footer">
    <div v-html="content"></div>
  </div>
  <!-- <div>
    <div v-html="content"></div>
  </div> -->
</template>

<script>
  export default {
    data() {
      return {
        content: "信息加载中..."
      }
    },
    mounted() {
      this.$axios.get("/web/index/foot").then(res => {
        if (res.code == 0) {
          this.content = res.data;
        }
      });
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/temp/components/footBody.vue